/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryParams, StringParam } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import ClientsTable from './ClientsTable';
import { ClientStatus } from '../common/interfaces/client.interface';

export interface ClientTableQueryProps extends IPaginationQueryParams {
    search?: string;
    status?: ClientStatus;
}

export type ClientTableBasicProps = IHOCQueryProps<ClientTableQueryProps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
    orderBy: 'created_at',
    orderDirection: OrderDirection.DESC,
});

const ClientTableWithQueryParams = () => {
    const queryConfig = {
        ...DEFAULT_QUERY_PARAMS,
        search: StringParam,
        status: StringParam,
    };

    return (
        <QueryParams config={queryConfig}>
            {(props: any) => {
                return <ClientsTable {...props} />;
            }}
        </QueryParams>
    );
};

export default ClientTableWithQueryParams;
